import { Preview } from '@components/ArtBoard/NodePreviewWrapper/components/Preview'
import { Tooltip } from '@lib/components'
import { thunkChangeCollapseNode } from '@store/migrationActions/thunkActions/thunkNodesActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import cx from 'classnames'
import type React from 'react'
import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { TREE_MATRIX } from '@/constants/constants'
import { useToggle } from '@/hooks'
import css from './NodePreviewWrapper.module.scss'

type Props = {
  nodeId: string
  withoutPreview?: boolean
}

const NodePreviewWrapper: React.FC<Props> = ({ nodeId, withoutPreview }) => {
  const buttonRef = useRef<HTMLDivElement>(null)

  const [isOpen, _, { turnOff: setClosed, turnOn: setOpened }] = useToggle()

  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const treeMode = useSelector(migrationProjectSelector.getProjectTreeType)

  const childIdsLength = useSelector(
    migrationProjectSelector.getProjectNodeChildIdsLength(nodeId)
  )

  const onCollapse = () => {
    dispatch(thunkChangeCollapseNode(nodeId))
  }

  const handleMouseEnter = () => {
    setOpened()
  }

  const handleMouseLeave = () => {
    setClosed()
  }

  return (
    <div className={css.wrapper}>
      <Tooltip
        content="Expand"
        position="top"
        onClick={onCollapse}
        className={cx(css.button, {
          [css.matrix]: treeMode === TREE_MATRIX,
        })}
      >
        <div
          ref={buttonRef}
          className={css.buttonContent}
          data-collapsed-badge
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {childIdsLength} {childIdsLength === 1 ? 'page' : 'pages'}
        </div>
      </Tooltip>
      {!withoutPreview && (
        <Preview buttonRef={buttonRef} nodeId={nodeId} isOpen={isOpen} />
      )}
    </div>
  )
}

export default NodePreviewWrapper
